module.exports = __webpack_public_path__ + "static/media/p2s3.a1b1dcf5.jpg";